import { useState } from "react";
import { fmtDate } from "./rx/rxShared";
import { History } from "lucide-react";

const SOURCES = [["prescription_visit", "Prescription visit"], ["progress_note", "Signed progress note"], ["med_review", "Clinician review"]];

function MedsTable({ meds }) {
  if (!meds.length) return <p className="py-3 text-xs text-[#7B6157]">No medications recorded in this source.</p>;
  return (
    <div className="mt-2 overflow-x-auto rounded-xl border border-[#EFEBE0] bg-white">
      <table className="w-full text-xs"><thead><tr className="bg-[#F5F2EB] text-left text-[10px] uppercase text-[#6D4C41]">
        {["Medication", "Dose", "Route", "Frequency", "Prescriber", "Status"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
        <tbody>{meds.map((m, i) => (
          <tr key={`${m.medication}-${i}`} className="border-t border-[#EFEBE0] text-[#5D4037]" data-testid={`session-meds-row-${i}`}>
            <td className="px-3 py-2 font-semibold text-[#3E2723]">{m.medication} {m.strength}</td><td className="px-3 py-2">{m.dose || "-"}</td>
            <td className="px-3 py-2">{m.route || "-"}</td><td className="px-3 py-2">{m.frequency || "-"}</td><td className="px-3 py-2">{m.prescriber || "-"}</td>
            <td className="px-3 py-2">{m.status || "-"}</td></tr>))}</tbody></table>
    </div>
  );
}

/** Latest session medications from three sources, each with its own "as of" date. */
export function SessionMedsSnapshot({ data }) {
  const [pick, setPick] = useState(null);
  if (!data) return null;
  const key = pick || data.latest || "prescription_visit";
  const src = data.sources[key];
  return (
    <div className="rounded-2xl border border-[#EFEBE0] bg-[#FDFCF8] p-4" data-testid="session-meds">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div><div className="flex items-center gap-2 text-sm font-bold text-[#3E2723]"><History size={14} /> Latest session meds</div>
          <p className="text-[11px] text-[#7B6157]">Each source has its own date. The newest one is selected first.</p></div>
        <div className="flex flex-wrap gap-1.5" role="tablist" aria-label="Medication source">
          {SOURCES.map(([k, label]) => {
            const s = data.sources[k];
            return (
              <button key={k} type="button" role="tab" aria-selected={key === k} disabled={!s} data-testid={`session-meds-tab-${k}`} onClick={() => setPick(k)}
                className={`rounded-full px-3 py-1 text-[11px] font-semibold transition-colors disabled:opacity-50 ${key === k ? "bg-[#4E342E] text-white" : "bg-white text-[#5D4037] ring-1 ring-[#E5DFD3] hover:bg-[#F5F2EB]"}`}>
                {label}{s ? `, ${fmtDate(s.date)}` : ", none yet"}{data.latest === k ? " (latest)" : ""}
              </button>
            );
          })}
        </div>
      </div>
      {src ? <>
        <div className="mt-2 text-[11px] text-[#6D4C41]" data-testid="session-meds-asof">As of {fmtDate(src.date)}{src.by ? `, ${src.by}` : ""}{src.detail ? `. ${src.detail}` : ""}</div>
        <MedsTable meds={src.meds} />
      </> : <p className="mt-3 text-xs text-[#7B6157]" data-testid="session-meds-empty">No prescription visit, signed progress note, or clinician medication review on file yet.</p>}
    </div>
  );
}
